export const regexRull = {
    fullWidth: /[\u3000-\u3003\u3008-\u3011\u3014-\u3015\u301C-\u301E\uFF01-\uFF5E]/g
}

export const regex = (reg, data) => {
    // 有帶入regex規則就進行資料比對
    if (!reg) return;
    return (String(data)).match(reg);
}